import { GetDocumentListResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetDocumentListModel } from './get-document-list.state';

/** StateDetailsActions */
const ACTION_SET = '[GetDocumentList] set';
const ACTION_UPDATE = '[GetDocumentList] update';
const ACTION_RESET = '[GetDocumentList] reset';
const ACTION_FAIL = '[GetDocumentList] fail';
const ACTION_CANCEL_REQUEST = '[GetDocumentList] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetDocumentList] set from api';
const ACTION_UPDATE_FROM_API = '[GetDocumentList] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetDocumentList = createAction(ACTION_SET, props<WithRequestId<GetDocumentListModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetDocumentList = createAction(ACTION_UPDATE, props<WithRequestId<Partial<GetDocumentListModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetDocumentList = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetDocumentListRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetDocumentList = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetDocumentListFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetDocumentListFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListResponse>>()
);
